/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Datastore API
 * API reference for Datastore API.
 *
 * Authentication: Auth0
 *
 * OpenAPI spec version: 3.0.0
 */
import type {
  GetImportRunsParams,
  GetImportRunsResponse
} from '../model';

import getImportRunsMutator from '../../../mutators/datastore-instance';



  /**
 * 組織内の取込実行履歴を時系列降順（created_at DESC, id DESC）で取得します。
 * import_rule_id を指定すると特定ルールの履歴のみ返します。
 * @summary 取込実行履歴一覧取得
 */
export const getImportRuns = (
    params?: GetImportRunsParams,
 ) => {
      return getImportRunsMutator<GetImportRunsResponse>(
      {url: `/external-storages/import-runs`, method: 'GET',
        params
    },
      );
    }
  export type GetImportRunsResult = NonNullable<Awaited<ReturnType<typeof getImportRuns>>>
